// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Timer_countdown__VaIWE"};